module.exports = __webpack_public_path__ + "static/media/how-to-2.9a318f5d.svg";